import React, { Component } from 'react';

import CloseIcon from '@material-ui/icons/Close';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogTitle, IconButton, Tab, Tabs, Typography } from '@material-ui/core';

import DriverQueue, { DriverQueueState } from '../../../models/DriverQueue';

import DriverQueueList from './DriverQueueList';
import ResponseError from '../../../models/ResponseError';
import { receiveError } from '../../../store/actions/notificationAction';
import { setAirlinesAction, setCounterAction } from '../../../store/actions/countersAction';
import { connect } from 'react-redux';
import CounterSelectModal from './CounterSelectModal';
import queueRemote from '../../../api/queueRemote';
import ApiResponse from '../../../models/ApiResponse';
import User from '../../../models/User';

import commonStyles from '../../common/common.module.css';

import walkIn from '../../../assets/walkin.svg';
import appointment from '../../../assets/appointment.svg';
import { removeWaitList } from '../../../store/actions/waitListAction';
import GhaModel from '../../../models/Gha';

const styles = (theme: Theme) =>

  createStyles({
    dialogPaper: {
      maxHeight: '60%',
      width: '80%'
    },
    dialogTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      color: 'var(--primaryblue)',
      fontSize: '25px'
    },
    close: {
      fontSize: '27px'
    },
    dashHeadWrapper: {
      borderRight: '4px solid var(--secondarygreen)',
      paddingRight: '20px',
      marginTop: 'auto',
      marginBottom: 'auto'
    },
    digit: { 
      fontSize: '44px', 
      fontWeight: 400, 
      paddingLeft: '20px',
      color: 'var(--primaryblue)',
      marginTop: '0',
      marginBottom: '0'
    },
    dashHeadLabel: {
      fontSize: '11px',
      fontWeight: 600,
      textTransform: 'uppercase',
      color: 'var(--primaryblue)',
      marginTop: '6px',
      marginBottom: '0',
      fontFamily: 'Nunito',
      lineHeight: 'normal'
    },
    dashHeadImg: {
      height: '30px',
      margin: 'auto',
      display: 'block',
      marginBottom: '2px',
      filter: 'invert(2%) sepia(0%) saturate(92%) hue-rotate(723.7deg) brightness(87.2%) contrast(99.5%)'
    },
    minsText: { 
      fontSize: '20px', 
      paddingLeft: '10px' 
    },
    '@media (max-width: 959px)':{
      waitlistWrapper: {
        order: 3,
        width:'100%'
      },
    },
    '@media (max-width: 480px)':{
      dialogPaper: {
        margin: '0px',
        width:'90%'
      },
    },
    activeTab: {
      '&.MuiTab-textColorInherit.Mui-selected': {
        backgroundColor: 'var(--primaryblue) !important',
      }
    },
    tabWrapper: {
      '& .MuiTabs-indicator': {
        display: 'none'
      }
    }
  });

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
};

interface DriverQueueListModalProps {
  classes: any;
  queue: Array<DriverQueue>;
  user: User;
  deleteDriverInQueue: (id: number) => void;
  createNewOrder: (data: DriverQueue) => void;
  isOpenWaitingList: boolean;
  handleCloseWaitingList: () => void;
  type: string;
  counters:any;
  setCounter: (id: number) => void;
  counterId: number;
  counterSelectModal: boolean;
  closeDialog: Function;
  receiveError: (error: ResponseError) => void;
  appoints: number;
  walkIns: number;
  driverQueueState: DriverQueueState;
  removeFromCounter: (driverId: number) => void;
  setCounterAirlines: (airlines: string[]) => void;
  airlines: string[];
  gha: GhaModel;
  airlineCounters: Array<string>;
};

interface DriverQueueListModalState {
  tabValue: number;
  serving: Array<DriverQueue>;
  driverQueue: Array<DriverQueue>;
  view: boolean;
  selectedAirlines: string[];
  showAirlineFilter: boolean;
};

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-prevent-tabpanel-${index}`}
      aria-labelledby={`scrollable-prevent-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Typography>{children}</Typography>
      )}
    </div>
  );
}

class DriverQueueListModal extends Component<DriverQueueListModalProps, DriverQueueListModalState> {

  state: Readonly<DriverQueueListModalState> = {
    tabValue: 0,
    serving: [],
    view: false,
    driverQueue: [],
    selectedAirlines: [],
    showAirlineFilter: false
  };

  componentDidMount() {
    this.filterQueue(this.props.driverQueueState.serving);
  }

  componentDidUpdate(prevProps: DriverQueueListModalProps) {
    if(prevProps.driverQueueState.serving.length !== this.props.driverQueueState.serving.length) {
      this.filterQueue(this.props.driverQueueState.serving);
    }
    if(prevProps.driverQueueState.queue.length !== this.props.driverQueueState.queue.length) {
      this.filterQueue(this.props.driverQueueState.queue);
    }
    if(prevProps.driverQueueState.whsQueue.length !== this.props.driverQueueState.whsQueue.length || prevProps.driverQueueState.whsServing.length !== this.props.driverQueueState.whsServing.length) {
      this.changeView(this.state.view);
    }
  }

  setCounter = (event: any): void => {
    if( event.target) {
      const id = event.target.value;
      queueRemote.selectCounter(id).then((res: ApiResponse<any>) => {
        const result: any | undefined = res.result;
        const error: ResponseError | undefined = res.error;
  
        if (result) {
          this.props.closeDialog(false);
          this.props.setCounter(result.id);
          if(result.info && result.info.ailrines) {
            this.props.setCounterAirlines(result.info.ailrines);
          }
        }
        if(result == null) {
          this.props.setCounter(0);
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      });
    }
    
  }

  filterQueue = (listQueue: Array<DriverQueue>): void => {
    const filterType: string = this.props.type === 'po' ? 'import' : 'export';
    const serving: Array<DriverQueue> = listQueue.filter(item => item.info.type === filterType);
    const showAirlineFilter =
    this.props.gha &&
    this.props.gha.system_parameters &&
    this.props.gha.system_parameters.forms &&
    this.props.gha.system_parameters.forms.driver_checkin &&
    this.props.gha.system_parameters.forms.driver_checkin.mandatory_fields &&
    this.props.gha.system_parameters.forms.driver_checkin.mandatory_fields.includes('airlines');
    this.setState({ serving, driverQueue: this.props.queue, showAirlineFilter, selectedAirlines: this.props.airlines }, () => {
      if(showAirlineFilter) {
        this.filterAirlines(this.props.airlines);
      }
    });
  }

  changeTabValue = (event: React.ChangeEvent<{}>, newValue: number): void => {
    let tabValue = 0;
    tabValue = newValue;
    this.setState({ tabValue });
  };

  handleChange = (event: any) => {
    const selectedAirlines = event.target.value;
  
    this.setState({ selectedAirlines }, () => {
      this.filterAirlines(selectedAirlines);
    });
  
  };

  filterAirlines = (airlines: string[]) => {
    const driverQueue = this.props.queue.filter(item => 
      !airlines.length || (item.info.airlines && item.info.airlines.some(airline => airlines.includes(airline)))
    );
    this.setState({ driverQueue });
  }

  changeView = (view: boolean): void => {
    if(view) {
      const filterType: string = this.props.type === 'po' ? 'import' : 'export';
      const serving: Array<DriverQueue> = this.props.driverQueueState.whsQueue.concat(this.props.driverQueueState.whsServing).filter(item => {
        return item.info.type === filterType
      })
      this.setState({ serving, view });
    } else {
      const filterType: string = this.props.type === 'po' ? 'import' : 'export';
      const serving: Array<DriverQueue> = this.props.driverQueueState.serving.filter(item => item.info.type === filterType);
      this.setState({ serving, view });
    }

  }

  moveDriver = (driver: DriverQueue) => {
    this.props.removeFromCounter(driver.id);
  }

  markAsCompleted = (driver: DriverQueue) => {
    queueRemote.callDriver(driver.id, 'complete').then((res: ApiResponse<any>) => {
      const result: any | undefined = res.success;
      const error: ResponseError | undefined = res.error;

      if (result) {
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  linkToOrder = (id: number): void => {
    if(this.props.counterId) {
      if(this.props.user.gha_id) {
        queueRemote.insertDriverAppointment(this.props.user.gha_id, 'appointment', '', id).then((res: ApiResponse<any>) => {
          const result: any | undefined = res.success;
          const error: ResponseError | undefined = res.error;
    
          if (result) {
          }
    
          if (error) {
            this.props.receiveError(error);
          }
        });
      }
     
    } else {
      this.props.closeDialog(true);
    }
  }


  render() {

    const classes = this.props.classes;
    const textTitleSuffix: string = this.props.type === 'po' ? 'Import' : 'Export';
    return (
    <Dialog
      open={ this.props.isOpenWaitingList }
      onClose={ this.props.handleCloseWaitingList }
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth={ 'xl' }
      classes={{ paper: this.props.classes.dialogPaper }}
      
    >
      <DialogTitle id="form-dialog-title">
        <div className={ this.props.classes.dialogTitle }>
          <span className={`${ commonStyles.myauto }`}>Driver Queue List { textTitleSuffix }</span>
          <div className={`${ commonStyles.fEvenly } ${ commonStyles.fAuto } ${ this.props.classes.waitlistWrapper }`}>
            <div className={`${ commonStyles.fRow }`}>
              <div className={`${ this.props.classes.dashHeadWrapper }`}>
                <img src={ appointment } alt='appointment' className={`${ this.props.classes.dashHeadImg }`} />
                <p className={`${ this.props.classes.dashHeadLabel }`}>appointments</p>
              </div>
                <p className={`${ this.props.classes.digit }`}>{ this.props.appoints }</p>
            </div>
            <div className={`${ commonStyles.fRow }`}>
              <div className={`${ this.props.classes.dashHeadWrapper }`}>
                <img src={ walkIn } alt='walk In' className={`${ this.props.classes.dashHeadImg }`} />
                <p className={`${ this.props.classes.dashHeadLabel }`}>walk ins</p>
              </div>
                <p className={`${ this.props.classes.digit }`}>{ this.props.walkIns }</p>
            </div>
          </div>
          <IconButton aria-label="Close" onClick={ this.props.handleCloseWaitingList } className={ this.props.classes.close }>
            <CloseIcon color='primary' fontSize='inherit'/>
          </IconButton>
        </div>
        <hr/>
      </DialogTitle>
      <DialogContent>
        <Tabs
            value={ this.state.tabValue }
            onChange={ this.changeTabValue }
            scrollButtons="off"
            aria-label="scrollable prevent tabs example"
            className={ `${commonStyles.tabContainer} ${commonStyles.mb4} ${classes.tabWrapper}` }
            variant="fullWidth"
          >
            <Tab className={ `${commonStyles.tab} ${classes.activeTab} $` } label="Driver Queue List" />
            <Tab className={ `${commonStyles.tab} ${classes.activeTab} $` } label="Now Serving List" />
        </Tabs>


        <TabPanel value={this.state.tabValue} index={0}>
          <DriverQueueList 
            queue={ this.state.driverQueue }
            deleteDriverInQueue={ this.props.deleteDriverInQueue }
            createNewOrder={ this.props.createNewOrder }
            isUsedToModal={ true }
            linkOrder={ this.linkToOrder }
            type={ 'queue' }
            airlines={ this.props.airlines }
            selectedAirlines={ this.state.selectedAirlines }
            handleChange={ this.handleChange }
            showAirlineFilter={ this.state.showAirlineFilter }
          />
        </TabPanel>
        <TabPanel value={this.state.tabValue} index={1}>
          <DriverQueueList 
            queue={ this.state.serving }
            deleteDriverInQueue={ this.props.deleteDriverInQueue }
            createNewOrder={ this.moveDriver }
            isUsedToModal={ true }
            linkOrder={ this.linkToOrder }
            type={ 'serving' }
            view={ this.state.view }
            handleChangeDataView={ this.changeView }
            completeDriver={ this.markAsCompleted }
            airlines={ this.props.airlines }
            selectedAirlines={ this.state.selectedAirlines }
            handleChange={ this.handleChange }
            showAirlineFilter={ this.state.showAirlineFilter }
          />
        </TabPanel>
        {
          this.props.counterSelectModal && 
          <CounterSelectModal
            closeDialog={ this.props.closeDialog }
            counterId={ this.props.counterId }
            counters={ this.props.counters }
            selectCounter={ this.setCounter }

          />
        }
      </DialogContent>
    </Dialog>
  )
  }
  
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    counters: state.countersAvailable,
    driverQueueState: state.driverQueue,
    counterId: state.userCounter,
    gha: state.ghaInfo,
    airlineCounters: state.counterAirlines
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    setCounter: (counterId: number) => dispatch(setCounterAction(counterId)),
    removeFromCounter: (id: number) => dispatch(removeWaitList(id)),
    setCounterAirlines: (airlines: string[]) => dispatch(setAirlinesAction(airlines))
  };
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(DriverQueueListModal));